import React, { Component } from 'react';
import {sendEvent} from "../../helpers/analytics";

class Question extends Component {
  state = {
    question: 0,
    answer: null,
    score: 0
  }

  componentWillMount () {
    this.props.start()
  }

  questions = [
    {
      id: 0,
      title: 'Какой гонщик Porsche сумел пробиться в «Формулу-1» уже после победы в ЧМ по гонкам на выносливость?',
      variants: [
        {text: 'Марк Уэббер', id: 1, score: 0},
        {text: 'Брендон Хартли', id: 0, score: 1},
        {text: 'Нил Яни', id: 2, score: 0},
        {text: 'Нико Хюлькенберг', id: 3, score: 0}
      ]
    },
    {
      id: 1,
      title: 'Сколько полных сезонов потребовалось двигателю TAG-Porsche, чтобы стать чемпионом «Формулы-1» вместе с «Маклареном»?',
      variants: [
        {text: 'Два', id: 1, score: 0},
        {text: 'Четыре', id: 2, score: 0},
        {text: 'Шесть', id: 3, score: 0},
        {text: 'Один', id: 0, score: 1},

      ]
    },
    {
      id: 2,
      title: 'Этот гонщик вместе с Porsche побеждал в «24 часах Ле-Мана» и поднимался на подиум «Дакара».',
      variants: [
        {text: 'Дерек Белл', id: 1, score: 0},
        {text: 'Ханс-Йоахим Штук', id: 2, score: 0},
        {text: 'Жаки Икс', id: 0, score: 1},
        {text: 'Рене Метж', id: 3, score: 0}
      ]
    },
    {
      id: 3,
      title: 'Сколько лошадиных сил мог выдавать в 1970-х Porsche 917 для серии Can-Am?',
      variants: [
        {text: '1130 л.с.', id: 1, score: 0},
        {text: '1460 л.с.', id: 2, score: 0},
        {text: '1580 л.с.', id: 0, score: 1},
        {text: '1690 л.с.', id: 3, score: 0}
      ]
    },
    {
      id: 4,
      title: 'На «24 часах Ле-Мана» 1982 года Porsche выставил новую модель 956. Чем закончился дебют?',
      variants: [
        {text: 'Победный дубль', id: 1, score: 0},
        {text: 'Три первых места', id: 0, score: 1},
        {text: 'Один из экипажей попал на подиум', id: 2, score: 0},
        {text: 'С ходу попасть на подиум не вышло', id: 3, score: 0}
      ]
    },
    {
      id: 5,
      title: 'Сколько минут длится заезд Porsche Sport Challenge?',
      variants: [
        {text: '20', id: 1, score: 0},
        {text: '30', id: 0, score: 1},
        {text: '25', id: 2, score: 0},
        {text: '40', id: 3, score: 0}
      ]
    },
    {
      id: 6,
      title: 'Этот гонщик «Формулы-1» выиграл «24 часа Ле-Мана» с Porsche с первой попытки.',
      variants: [
        {text: 'Марк Уэббер', id: 1, score: 0},
        {text: 'Брендон Хартли', id: 2, score: 0},
        {text: 'Нико Хюлькенберг', id: 0, score: 1},
        {text: 'Фернандо Алонсо', id: 3, score: 0}
      ]
    },
    {
      id: 7,
      title: 'В Porsche были очень близки к победе на легендарном ралли «Сафари». Сколько раз экипажи команды занимали второе место в гонке?',
      variants: [
        {text: '3', id: 0, score: 1},
        {text: '2', id: 1, score: 0},
        {text: '5', id: 2, score: 0},
        {text: '6', id: 3, score: 0}
      ]
    },
    {
      id: 8,
      title: 'Второе чемпионство Алена Проста с моторами TAG-Porsche было оформлено после схода одного из главных конкурентов. Кому не повезло в решающей гонке «Ф-1»?',
      variants: [
        {text: 'Нельсону Пике', id: 1, score: 0},
        {text: 'Айртону Сенне', id: 2, score: 0},
        {text: 'Найджелу Мэнселлу', id: 0, score: 1},
        {text: 'Кеке Росбергу', id: 3, score: 0}
      ]
    },
    {
      id: 10,
      title: 'Доктором чего является бывший заводской гонщик Porsche Хельмут Марко, выигравший с командой «24 часа Ле-Мана-1971»?',
      variants: [
        {text: 'Права', id: 0, score: 1},
        {text: 'Исторических наук', id: 1, score: 0},
        {text: 'Социологических наук', id: 2, score: 0},
        {text: 'Философии', id: 3, score: 0}
      ]
    },
    {
      id: 11,
      title: 'В каком году автомобиль Porsche впервые выиграл знаменитый марафон Targa Florio?',
      variants: [
        {text: '1955', id: 1, score: 0},
        {text: '1953', id: 2, score: 0},
        {text: '1959', id: 3, score: 0},
        {text: '1956', id: 0, score: 1},
      ]
    },
    {
      id: 12,
      title: 'В каком аспекте турбомотор TAG-Porsche для «Формулы-1» долгое время давал фору всем соперникам?',
      variants: [
        {text: 'Мощность', id: 1, score: 0},
        {text: 'Экономичность', id: 0, score: 1},
        {text: 'Стоимость', id: 2, score: 0},
        {text: 'Угол развала блока цилиндров', id: 3, score: 0}
      ]
    },
    {
      id: 13,
      title: 'Знаменитая Porsche 936 неоднократно выигрывала «24 часа Ле-Мана». Сколько побед на ее счету?',
      variants: [
        {text: '3', id: 0, score: 1},
        {text: '2', id: 1, score: 0},
        {text: '5', id: 2, score: 0},
        {text: '6', id: 3, score: 0}
      ]
    },
    {
      id: 14,
      title: 'Какой гонщик принес Porsche первую победу в «Формуле-1»?',
      variants: [
        {text: 'Ален Прост', id: 1, score: 0},
        {text: 'Дэн Герни', id: 0, score: 1},
        {text: 'Ники Лауда', id: 2, score: 0},
        {text: 'Штефан Беллоф', id: 3, score: 0}
      ]
    },
    {
      id: 15,
      title: 'Чем примечательна машина Porsche 911 Carrera RSR?',
      variants: [
        {text: 'Первый автомобиль Porsche на «24 часах Ле-Мана»', id: 1, score: 0},
        {text: 'Автор рекорда максимальной скорости на «24 часах Ле-Мана»', id: 2, score: 0},
        {text: 'Автомобиль с инновационной для своего времени системой тормозов', id: 3, score: 0},
        {text: 'Первый автомобиль на «24 часах Ле-Мана» с турбомотором', id: 0, score: 1},
      ]
    },
    {
      id: 16,
      title: 'ЧВ каком году моторы Porsche в последний раз были представлены в «Формуле-1»?',
      variants: [
        {text: '1987', id: 1, score: 0},
        {text: '1993', id: 2, score: 0},
        {text: '1991', id: 0, score: 1},
        {text: '1986', id: 3, score: 0}
      ]
    },
    {
      id: 17,
      title: 'Porsche 911 R установила целую серию мировых рекордов на овале в Монце во время заезда длиной в 96 часов. С какой проблемой столкнулись механики?',
      variants: [
        {text: 'Закончилось топливо', id: 1, score: 0},
        {text: 'Закончились дождевые шины', id: 0, score: 1},
        {text: 'Закончились запчасти', id: 2, score: 0},
        {text: 'Закончилась еда в столовой', id: 3, score: 0}
      ]
    },
  ]

  selectVariant = (id) => {
    this.setState({answer: id})
  }

  next = () => {
    let { score, question, answer }  = this.state
    if (answer === null) return
    sendEvent('game', 'load', 'question ' + question+1)
    score += this.questions[question].variants[answer].score
    answer = null
    console.log('score', score)

    if (question < this.questions.length-1) {
      question++
      this.setState({score, question, answer})
    } else {
      console.log('score', score)
      this.setState({score, answer})
      this.finish(score)
    }
  }

  finish = (score) => {
    this.props.sendScore(score)
    this.props.next(2)
  }

  renderVariants = () => {
    let { question, answer } = this.state;
    let activeQuestion = this.questions[question]

    return activeQuestion.variants.map((item, index) => {
      return (
        <li key={index} className={answer === index ? 'active' : null}
            id={index}
            onClick={() => this.selectVariant(index)}
        >
          {item.text}
         </li>
      )
    })

  }


  render () {
    let { question, answer } = this.state;
    let activeQuestion = this.questions[question]
    let btnClasses = "button button--primary"
    if (answer !== null) {
      btnClasses += " button--active"
    }
    return (
      <div className="test__question">
        <div className="question__title">{question+1}/{this.questions.length}</div>
        <div className="question__text" dangerouslySetInnerHTML={{__html:activeQuestion.title}} />

        <ul className="question__variants">
          {this.renderVariants()}
        </ul>

        <div className="question__button">
          <button className={btnClasses} onClick={() => this.next()}>далее</button>
        </div>
      </div>
    )
  }
}

export default Question


// WEBPACK FOOTER //
// ./src/pages/test/question_stage3.js